import { useEffect, useRef } from 'react';
import { useEmbeddedEditorContext } from './EmbeddedEditorContext';
import { getAnchorFromUrl, getAnchorTestId, removeAnchorFromUrl } from './utils';

// Use components/hooks here for anchor navigation after loading full app
// eg. when user navigates to a different pane containing it
import { jsx as _jsx } from "react/jsx-runtime";
export const navigateToAnchor = ({
  anchorNavigation,
  clearAnchorAfterNavigation = true
}) => {
  if (!anchorNavigation) return;
  const anchor = getAnchorFromUrl();
  if (anchor && anchorNavigation !== null && anchorNavigation !== void 0 && anchorNavigation[anchor]) {
    anchorNavigation[anchor]();
  }
  if (clearAnchorAfterNavigation) {
    removeAnchorFromUrl();
  }
};
export const useAnchorNavigation = ({
  extraAnchorNavigation,
  clearAnchorAfterNavigation
}) => {
  const {
    anchorNavigation
  } = useEmbeddedEditorContext();
  useEffect(() => {
    navigateToAnchor({
      anchorNavigation: Object.assign({}, anchorNavigation, extraAnchorNavigation),
      clearAnchorAfterNavigation
    });
  }, [anchorNavigation, extraAnchorNavigation, clearAnchorAfterNavigation]);
  return null;
};
export const useScrollToAnchorOnce = anchorRef => {
  const {
    anchorNavigation
  } = useEmbeddedEditorContext();
  useEffect(() => {
    if (!anchorRef.current) return;
    const anchor = getAnchorFromUrl();
    // Default scroll to anchor if it's not already handled by the anchorNavigation
    if (anchor && !(anchorNavigation !== null && anchorNavigation !== void 0 && anchorNavigation[anchor]) && anchorRef.current) {
      const anchorElement = anchorRef.current;
      anchorElement.scrollIntoView({
        behavior: 'smooth'
      });
      removeAnchorFromUrl();
    }
  }, [anchorNavigation, anchorRef]);
};
export const AnchorNavigation = ({
  extraAnchorNavigation
}) => {
  useAnchorNavigation({
    extraAnchorNavigation
  });
  return null;
};
export const StudioAnchorWrapper = ({
  anchor,
  children
}) => {
  const anchorRef = useRef(null);
  useScrollToAnchorOnce(anchorRef);
  if (!anchor) return children;
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": getAnchorTestId(anchor),
    ref: anchorRef,
    children: children
  });
};